import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { SearchIcon, FilterIcon, DownloadIcon, EyeIcon, CheckIcon, XIcon, AlertTriangleIcon, ClockIcon, CalendarIcon, DollarSignIcon, FileTextIcon, InfoIcon, ChevronDownIcon, PlusIcon } from 'lucide-react';
import Card from '../../components/ui/Card';
import Table from '../../components/ui/Table';
import StatusBadge from '../../components/ui/StatusBadge';
import Modal from '../../components/ui/Modal';
// Mock dispute data
const mockDisputes = [{
  id: 'DSP10001',
  merchantName: 'ABC Corporation',
  merchantId: 'MERCH001',
  transactionId: 'TXN789012',
  status: 'open',
  amount: 1250.75,
  currency: 'PKR',
  disputeType: 'chargeback',
  dateRaised: '2023-10-15T09:30:00Z',
  lastUpdated: '2023-10-15T09:30:00Z',
  description: 'Customer claims unauthorized transaction',
  customerName: 'John Smith',
  customerContact: 'john.smith@example.com',
  assignedTo: 'adminchecker',
  documents: ['receipt.pdf', 'communication.pdf'],
  timeline: [{
    date: '2023-10-15T09:30:00Z',
    action: 'Dispute raised',
    user: 'adminmaker',
    details: 'Dispute initiated by merchant'
  }]
}, {
  id: 'DSP10002',
  merchantName: 'XYZ Enterprises',
  merchantId: 'MERCH002',
  transactionId: 'TXN456789',
  status: 'under_review',
  amount: 750.5,
  currency: 'PKR',
  disputeType: 'refund',
  dateRaised: '2023-10-12T14:45:00Z',
  lastUpdated: '2023-10-14T11:20:00Z',
  description: 'Product not received by customer',
  customerName: 'Sarah Johnson',
  customerContact: 'sarah.j@example.com',
  assignedTo: 'adminchecker',
  documents: ['order_details.pdf'],
  timeline: [{
    date: '2023-10-12T14:45:00Z',
    action: 'Dispute raised',
    user: 'adminmaker',
    details: 'Dispute initiated by customer'
  }, {
    date: '2023-10-14T11:20:00Z',
    action: 'Status update',
    user: 'adminchecker',
    details: 'Dispute under review - contacting merchant for details'
  }]
}, {
  id: 'DSP10003',
  merchantName: 'Local Grocers',
  merchantId: 'MERCH003',
  transactionId: 'TXN123456',
  status: 'resolved',
  amount: 450.25,
  currency: 'PKR',
  disputeType: 'fraud',
  dateRaised: '2023-10-08T10:15:00Z',
  lastUpdated: '2023-10-11T16:30:00Z',
  description: 'Fraudulent transaction reported by cardholder',
  customerName: 'Michael Brown',
  customerContact: 'michael.b@example.com',
  assignedTo: 'adminmaker',
  documents: ['transaction_log.pdf', 'fraud_report.pdf'],
  timeline: [{
    date: '2023-10-08T10:15:00Z',
    action: 'Dispute raised',
    user: 'adminmaker',
    details: 'Fraud dispute initiated by bank'
  }, {
    date: '2023-10-10T09:45:00Z',
    action: 'Status update',
    user: 'adminchecker',
    details: 'Investigation initiated'
  }, {
    date: '2023-10-11T16:30:00Z',
    action: 'Status update',
    user: 'adminchecker',
    details: 'Dispute resolved in favor of customer - full refund processed'
  }]
}, {
  id: 'DSP10004',
  merchantName: 'Tech Solutions Inc',
  merchantId: 'MERCH004',
  transactionId: 'TXN345678',
  status: 'rejected',
  amount: 2500.0,
  currency: 'PKR',
  disputeType: 'chargeback',
  dateRaised: '2023-10-05T08:20:00Z',
  lastUpdated: '2023-10-09T13:10:00Z',
  description: 'Customer claims product quality issues',
  customerName: 'Emily Wilson',
  customerContact: 'emily.w@example.com',
  assignedTo: 'adminmaker',
  documents: ['product_photos.pdf', 'merchant_response.pdf'],
  timeline: [{
    date: '2023-10-05T08:20:00Z',
    action: 'Dispute raised',
    user: 'adminmaker',
    details: 'Dispute initiated by customer'
  }, {
    date: '2023-10-07T14:30:00Z',
    action: 'Status update',
    user: 'adminchecker',
    details: 'Merchant provided evidence of product quality'
  }, {
    date: '2023-10-09T13:10:00Z',
    action: 'Status update',
    user: 'adminmaker',
    details: 'Dispute rejected - evidence supports merchant position'
  }]
}, {
  id: 'DSP10005',
  merchantName: 'Metro Retailers',
  merchantId: 'MERCH005',
  transactionId: 'TXN901234',
  status: 'open',
  amount: 1800.5,
  currency: 'PKR',
  disputeType: 'refund',
  dateRaised: '2023-10-14T11:40:00Z',
  lastUpdated: '2023-10-14T11:40:00Z',
  description: 'Duplicate charge on customer account',
  customerName: 'David Lee',
  customerContact: 'david.l@example.com',
  assignedTo: 'adminchecker',
  documents: ['transaction_history.pdf'],
  timeline: [{
    date: '2023-10-14T11:40:00Z',
    action: 'Dispute raised',
    user: 'adminmaker',
    details: 'Dispute initiated for duplicate charge'
  }]
}, {
  id: 'DSP10006',
  merchantName: 'Coffee House Chain',
  merchantId: 'MERCH006',
  transactionId: 'TXN567890',
  status: 'under_review',
  amount: 350.75,
  currency: 'PKR',
  disputeType: 'chargeback',
  dateRaised: '2023-10-10T15:25:00Z',
  lastUpdated: '2023-10-13T10:05:00Z',
  description: 'Customer charged incorrect amount',
  customerName: 'Jessica Martinez',
  customerContact: 'jessica.m@example.com',
  assignedTo: 'adminmaker',
  documents: ['receipt.pdf', 'customer_statement.pdf'],
  timeline: [{
    date: '2023-10-10T15:25:00Z',
    action: 'Dispute raised',
    user: 'adminchecker',
    details: 'Dispute initiated by customer'
  }, {
    date: '2023-10-13T10:05:00Z',
    action: 'Status update',
    user: 'adminmaker',
    details: 'Merchant contacted for transaction details'
  }]
}, {
  id: 'DSP10007',
  merchantName: 'Fashion Boutique',
  merchantId: 'MERCH007',
  transactionId: 'TXN234567',
  status: 'resolved',
  amount: 1250.0,
  currency: 'PKR',
  disputeType: 'fraud',
  dateRaised: '2023-10-03T09:15:00Z',
  lastUpdated: '2023-10-08T14:30:00Z',
  description: 'Unauthorized transaction on customer card',
  customerName: 'Robert Taylor',
  customerContact: 'robert.t@example.com',
  assignedTo: 'adminchecker',
  documents: ['fraud_investigation.pdf', 'bank_statement.pdf'],
  timeline: [{
    date: '2023-10-03T09:15:00Z',
    action: 'Dispute raised',
    user: 'adminmaker',
    details: 'Fraud dispute initiated by bank'
  }, {
    date: '2023-10-05T11:20:00Z',
    action: 'Status update',
    user: 'adminchecker',
    details: 'Investigation initiated with payment processor'
  }, {
    date: '2023-10-08T14:30:00Z',
    action: 'Status update',
    user: 'adminmaker',
    details: 'Dispute resolved in favor of customer - transaction reversed'
  }]
}];
// Type definitions
interface DisputeTimeline {
  date: string;
  action: string;
  user: string;
  details: string;
}
interface Dispute {
  id: string;
  merchantName: string;
  merchantId: string;
  transactionId: string;
  status: 'open' | 'under_review' | 'resolved' | 'rejected';
  amount: number;
  currency: string;
  disputeType: 'chargeback' | 'refund' | 'fraud';
  dateRaised: string;
  lastUpdated: string;
  description: string;
  customerName: string;
  customerContact: string;
  assignedTo: string;
  documents: string[];
  timeline: DisputeTimeline[];
}
const DisputeList: React.FC = () => {
  const navigate = useNavigate();
  const [disputes, setDisputes] = useState<Dispute[]>(mockDisputes);
  const [filteredDisputes, setFilteredDisputes] = useState<Dispute[]>(mockDisputes);
  const [searchTerm, setSearchTerm] = useState('');
  const [showFilters, setShowFilters] = useState(false);
  const [statusFilter, setStatusFilter] = useState('');
  const [typeFilter, setTypeFilter] = useState('');
  const [dateFromFilter, setDateFromFilter] = useState('');
  const [dateToFilter, setDateToFilter] = useState('');
  const [amountMinFilter, setAmountMinFilter] = useState('');
  const [amountMaxFilter, setAmountMaxFilter] = useState('');
  // Detail view state
  const [selectedDispute, setSelectedDispute] = useState<Dispute | null>(null);
  const [showDetailModal, setShowDetailModal] = useState(false);
  // Status update state
  const [showStatusModal, setShowStatusModal] = useState(false);
  const [statusUpdateReason, setStatusUpdateReason] = useState('');
  const [newStatus, setNewStatus] = useState<Dispute['status']>('open');
  const [disputeToUpdate, setDisputeToUpdate] = useState<Dispute | null>(null);
  // Export state
  const [showExportModal, setShowExportModal] = useState(false);
  // Apply filters
  useEffect(() => {
    let result = disputes;
    // Search term filter
    if (searchTerm) {
      const term = searchTerm.toLowerCase();
      result = result.filter(dispute => dispute.id.toLowerCase().includes(term) || dispute.merchantName.toLowerCase().includes(term) || dispute.transactionId.toLowerCase().includes(term) || dispute.customerName.toLowerCase().includes(term));
    }
    // Status filter
    if (statusFilter) {
      result = result.filter(dispute => dispute.status === statusFilter);
    }
    // Type filter
    if (typeFilter) {
      result = result.filter(dispute => dispute.disputeType === typeFilter);
    }
    // Date range filter
    if (dateFromFilter) {
      const fromDate = new Date(dateFromFilter);
      result = result.filter(dispute => new Date(dispute.dateRaised) >= fromDate);
    }
    if (dateToFilter) {
      const toDate = new Date(dateToFilter);
      toDate.setHours(23, 59, 59, 999); // End of day
      result = result.filter(dispute => new Date(dispute.dateRaised) <= toDate);
    }
    // Amount range filter
    if (amountMinFilter) {
      const minAmount = parseFloat(amountMinFilter);
      result = result.filter(dispute => dispute.amount >= minAmount);
    }
    if (amountMaxFilter) {
      const maxAmount = parseFloat(amountMaxFilter);
      result = result.filter(dispute => dispute.amount <= maxAmount);
    }
    setFilteredDisputes(result);
  }, [disputes, searchTerm, statusFilter, typeFilter, dateFromFilter, dateToFilter, amountMinFilter, amountMaxFilter]);
  // Handle view details
  const handleViewDetails = (dispute: Dispute) => {
    setSelectedDispute(dispute);
    setShowDetailModal(true);
  };
  // Handle status update
  const openStatusUpdateModal = (dispute: Dispute, status: Dispute['status']) => {
    setDisputeToUpdate(dispute);
    setNewStatus(status);
    setStatusUpdateReason('');
    setShowStatusModal(true);
  };
  const updateDisputeStatus = () => {
    if (!disputeToUpdate || !statusUpdateReason) return;
    // Update the dispute status
    const updatedDisputes = disputes.map(dispute => {
      if (dispute.id === disputeToUpdate.id) {
        const updatedTimeline = [...dispute.timeline, {
          date: new Date().toISOString(),
          action: 'Status update',
          user: 'adminmaker',
          details: `Status changed to ${getStatusLabel(newStatus)} - ${statusUpdateReason}`
        }];
        return {
          ...dispute,
          status: newStatus,
          lastUpdated: new Date().toISOString(),
          timeline: updatedTimeline
        };
      }
      return dispute;
    });
    setDisputes(updatedDisputes);
    setShowStatusModal(false);
    setDisputeToUpdate(null);
    setStatusUpdateReason('');
  };
  // Handle export
  const handleExport = (format: 'csv' | 'xlsx' | 'pdf') => {
    // In a real app, this would trigger a download
    alert(`Exporting disputes in ${format.toUpperCase()} format`);
    setShowExportModal(false);
  };
  // Format date
  const formatDate = (dateString: string) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric'
    });
  };
  // Format amount
  const formatAmount = (amount: number, currency: string) => {
    return `${currency} ${amount.toLocaleString('en-US', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    })}`;
  };
  // Get status badge
  const getStatusBadge = (status: Dispute['status']) => {
    switch (status) {
      case 'open':
        return <StatusBadge status="warning" text="Open" data-id="element-2964" />;
      case 'under_review':
        return <StatusBadge status="info" text="Under Review" data-id="element-2965" />;
      case 'resolved':
        return <StatusBadge status="success" text="Resolved" data-id="element-2966" />;
      case 'rejected':
        return <StatusBadge status="danger" text="Rejected" data-id="element-2967" />;
      default:
        return <StatusBadge status="default" text={status} data-id="element-2968" />;
    }
  };
  // Get status label
  const getStatusLabel = (status: Dispute['status']) => {
    switch (status) {
      case 'open':
        return 'Open';
      case 'under_review':
        return 'Under Review';
      case 'resolved':
        return 'Resolved';
      case 'rejected':
        return 'Rejected';
      default:
        return status;
    }
  };
  // Get dispute type badge
  const getDisputeTypeBadge = (type: Dispute['disputeType']) => {
    switch (type) {
      case 'chargeback':
        return <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-purple-100 text-purple-800 dark:bg-purple-900/30 dark:text-purple-300" data-id="element-2969">
            Chargeback
          </span>;
      case 'refund':
        return <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-blue-100 text-blue-800 dark:bg-blue-900/30 dark:text-blue-300" data-id="element-2970">
            Refund
          </span>;
      case 'fraud':
        return <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-red-100 text-red-800 dark:bg-red-900/30 dark:text-red-300" data-id="element-2971">
            Fraud
          </span>;
      default:
        return <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-gray-100 text-gray-800 dark:bg-gray-700 dark:text-gray-300" data-id="element-2972">
            {type}
          </span>;
    }
  };
  // Reset filters
  const resetFilters = () => {
    setStatusFilter('');
    setTypeFilter('');
    setDateFromFilter('');
    setDateToFilter('');
    setAmountMinFilter('');
    setAmountMaxFilter('');
    setSearchTerm('');
  };
  // Table columns
  const columns = [{
    header: 'Dispute ID',
    accessor: 'id',
    sortable: true
  }, {
    header: 'Merchant',
    accessor: (dispute: Dispute) => <div data-id="element-2973">
          <div className="font-medium text-gray-900 dark:text-white" data-id="element-2974">
            {dispute.merchantName}
          </div>
          <div className="text-xs text-gray-500 dark:text-gray-400" data-id="element-2975">
            ID: {dispute.merchantId}
          </div>
        </div>
  }, {
    header: 'Transaction ID',
    accessor: 'transactionId',
    sortable: true
  }, {
    header: 'Status',
    accessor: (dispute: Dispute) => getStatusBadge(dispute.status),
    sortable: true
  }, {
    header: 'Type',
    accessor: (dispute: Dispute) => getDisputeTypeBadge(dispute.disputeType),
    sortable: true
  }, {
    header: 'Amount',
    accessor: (dispute: Dispute) => <div className="font-medium" data-id="element-2976">
          {formatAmount(dispute.amount, dispute.currency)}
        </div>,
    sortable: true
  }, {
    header: 'Date Raised',
    accessor: (dispute: Dispute) => formatDate(dispute.dateRaised),
    sortable: true
  }];
  return <div className="space-y-6" data-id="element-2977">
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between" data-id="element-2978">
        <h1 className="text-2xl font-bold text-gray-900 dark:text-white" data-id="element-2979">
          Dispute Management
        </h1>
        <div className="mt-3 sm:mt-0 flex flex-wrap gap-2" data-id="element-2980">
          <button onClick={() => setShowExportModal(true)} className="inline-flex items-center px-4 py-2 border border-gray-300 dark:border-gray-600 rounded-md shadow-sm text-sm font-medium text-gray-700 dark:text-gray-200 bg-white dark:bg-gray-800 hover:bg-gray-50 dark:hover:bg-gray-700" data-id="element-2981">
            <DownloadIcon className="h-4 w-4 mr-2" data-id="element-2982" />
            Export
          </button>
          <Link to="/disputes/new" className="inline-flex items-center px-4 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-blue-600 hover:bg-blue-700" data-id="element-2983">
            <PlusIcon className="h-4 w-4 mr-2" data-id="element-2984" />
            New Dispute
          </Link>
        </div>
      </div>

      {/* Search and Filters */}
      <div className="flex flex-col sm:flex-row gap-4" data-id="element-2985">
        <div className="relative flex-1" data-id="element-2986">
          <input type="text" placeholder="Search by Dispute ID, Merchant, or Transaction ID..." value={searchTerm} onChange={e => setSearchTerm(e.target.value)} className="w-full pl-10 pr-4 py-2 border border-gray-300 dark:border-gray-600 rounded-md shadow-sm text-sm bg-white dark:bg-gray-800" data-id="element-2987" />
          <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none" data-id="element-2988">
            <SearchIcon className="h-4 w-4 text-gray-400" data-id="element-2989" />
          </div>
        </div>
        <button onClick={() => setShowFilters(!showFilters)} className="inline-flex items-center px-4 py-2 border border-gray-300 dark:border-gray-600 rounded-md shadow-sm text-sm font-medium text-gray-700 dark:text-gray-200 bg-white dark:bg-gray-800 hover:bg-gray-50 dark:hover:bg-gray-700" data-id="element-2990">
          <FilterIcon className="h-4 w-4 mr-2" data-id="element-2991" />
          {showFilters ? 'Hide Filters' : 'Show Filters'}
        </button>
      </div>

      {/* Advanced Filters */}
      {showFilters && <Card data-id="element-2992">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4" data-id="element-2993">
            <div data-id="element-2994">
              <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1" data-id="element-2995">
                Status
              </label>
              <select value={statusFilter} onChange={e => setStatusFilter(e.target.value)} className="w-full rounded-md border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-800 py-2 px-3 text-sm" data-id="element-2996">
                <option value="" data-id="element-2997">All Statuses</option>
                <option value="open" data-id="element-2998">Open</option>
                <option value="under_review" data-id="element-2999">Under Review</option>
                <option value="resolved" data-id="element-3000">Resolved</option>
                <option value="rejected" data-id="element-3001">Rejected</option>
              </select>
            </div>
            <div data-id="element-3002">
              <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1" data-id="element-3003">
                Dispute Type
              </label>
              <select value={typeFilter} onChange={e => setTypeFilter(e.target.value)} className="w-full rounded-md border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-800 py-2 px-3 text-sm" data-id="element-3004">
                <option value="" data-id="element-3005">All Types</option>
                <option value="chargeback" data-id="element-3006">Chargeback</option>
                <option value="refund" data-id="element-3007">Refund</option>
                <option value="fraud" data-id="element-3008">Fraud</option>
              </select>
            </div>
            <div data-id="element-3009">
              <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1" data-id="element-3010">
                Date Range (From)
              </label>
              <div className="relative rounded-md shadow-sm" data-id="element-3011">
                <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none" data-id="element-3012">
                  <CalendarIcon className="h-5 w-5 text-gray-400" data-id="element-3013" />
                </div>
                <input type="date" value={dateFromFilter} onChange={e => setDateFromFilter(e.target.value)} className="w-full pl-10 pr-4 py-2 border border-gray-300 dark:border-gray-600 rounded-md shadow-sm text-sm bg-white dark:bg-gray-800" data-id="element-3014" />
              </div>
            </div>
            <div data-id="element-3015">
              <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1" data-id="element-3016">
                Date Range (To)
              </label>
              <div className="relative rounded-md shadow-sm" data-id="element-3017">
                <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none" data-id="element-3018">
                  <CalendarIcon className="h-5 w-5 text-gray-400" data-id="element-3019" />
                </div>
                <input type="date" value={dateToFilter} onChange={e => setDateToFilter(e.target.value)} className="w-full pl-10 pr-4 py-2 border border-gray-300 dark:border-gray-600 rounded-md shadow-sm text-sm bg-white dark:bg-gray-800" data-id="element-3020" />
              </div>
            </div>
            <div data-id="element-3021">
              <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1" data-id="element-3022">
                Amount (Min)
              </label>
              <div className="relative rounded-md shadow-sm" data-id="element-3023">
                <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none" data-id="element-3024">
                  <DollarSignIcon className="h-5 w-5 text-gray-400" data-id="element-3025" />
                </div>
                <input type="number" placeholder="Min Amount" value={amountMinFilter} onChange={e => setAmountMinFilter(e.target.value)} className="w-full pl-10 pr-4 py-2 border border-gray-300 dark:border-gray-600 rounded-md shadow-sm text-sm bg-white dark:bg-gray-800" data-id="element-3026" />
              </div>
            </div>
            <div data-id="element-3027">
              <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1" data-id="element-3028">
                Amount (Max)
              </label>
              <div className="relative rounded-md shadow-sm" data-id="element-3029">
                <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none" data-id="element-3030">
                  <DollarSignIcon className="h-5 w-5 text-gray-400" data-id="element-3031" />
                </div>
                <input type="number" placeholder="Max Amount" value={amountMaxFilter} onChange={e => setAmountMaxFilter(e.target.value)} className="w-full pl-10 pr-4 py-2 border border-gray-300 dark:border-gray-600 rounded-md shadow-sm text-sm bg-white dark:bg-gray-800" data-id="element-3032" />
              </div>
            </div>
          </div>
          <div className="mt-4 flex justify-end space-x-3" data-id="element-3033">
            <button onClick={resetFilters} className="px-4 py-2 border border-gray-300 dark:border-gray-600 rounded-md text-sm font-medium text-gray-700 dark:text-gray-200 bg-white dark:bg-gray-800 hover:bg-gray-50 dark:hover:bg-gray-700" data-id="element-3034">
              Reset
            </button>
            <button onClick={() => setShowFilters(false)} className="px-4 py-2 border border-transparent rounded-md text-sm font-medium text-white bg-blue-600 hover:bg-blue-700" data-id="element-3035">
              Apply Filters
            </button>
          </div>
        </Card>}

      {/* Disputes Table */}
      <Card data-id="element-3036">
        <div className="mb-4 flex items-center justify-between" data-id="element-3037">
          <div className="text-sm text-gray-500 dark:text-gray-400" data-id="element-3038">
            Showing {filteredDisputes.length} disputes
          </div>
        </div>
        <Table columns={columns} data={filteredDisputes} keyField="id" onRowClick={handleViewDetails} actions={dispute => <div className="flex space-x-2 justify-end" data-id="element-3040">
              <button onClick={e => {
          e.stopPropagation();
          handleViewDetails(dispute);
        }} className="text-blue-600 hover:text-blue-800 dark:text-blue-400 dark:hover:text-blue-300" title="View Details" data-id="element-3041">
                <EyeIcon className="h-5 w-5" data-id="element-3042" />
              </button>
              {dispute.status !== 'resolved' && dispute.status !== 'rejected' && <>
                    <button onClick={e => {
            e.stopPropagation();
            openStatusUpdateModal(dispute, 'resolved');
          }} className="text-green-600 hover:text-green-800 dark:text-green-400 dark:hover:text-green-300" title="Resolve Dispute" data-id="element-3043">
                      <CheckIcon className="h-5 w-5" data-id="element-3044" />
                    </button>
                    <button onClick={e => {
            e.stopPropagation();
            openStatusUpdateModal(dispute, 'rejected');
          }} className="text-red-600 hover:text-red-800 dark:text-red-400 dark:hover:text-red-300" title="Reject Dispute" data-id="element-3045">
                      <XIcon className="h-5 w-5" data-id="element-3046" />
                    </button>
                  </>}
              {dispute.status === 'open' && <button onClick={e => {
          e.stopPropagation();
          openStatusUpdateModal(dispute, 'under_review');
        }} className="text-yellow-600 hover:text-yellow-800 dark:text-yellow-400 dark:hover:text-yellow-300" title="Mark Under Review" data-id="element-3047">
                  <ClockIcon className="h-5 w-5" data-id="element-3048" />
                </button>}
            </div>} data-id="element-3039" />
      </Card>

      {/* Dispute Detail Modal */}
      {selectedDispute && <Modal isOpen={showDetailModal} onClose={() => setShowDetailModal(false)} title={`Dispute Details - ${selectedDispute.id}`} size="lg" data-id="element-3049">
          <div className="space-y-6" data-id="element-3050">
            {/* Status and Actions */}
            <div className="flex flex-wrap justify-between items-center pb-4 border-b dark:border-gray-700" data-id="element-3051">
              <div className="flex items-center space-x-2" data-id="element-3052">
                <span className="text-sm text-gray-500 dark:text-gray-400" data-id="element-3053">
                  Status:
                </span>
                {getStatusBadge(selectedDispute.status)}
              </div>
              <div className="flex space-x-2 mt-2 sm:mt-0" data-id="element-3054">
                {selectedDispute.status !== 'resolved' && selectedDispute.status !== 'rejected' && <>
                      <button onClick={() => {
                setShowDetailModal(false);
                openStatusUpdateModal(selectedDispute, 'resolved');
              }} className="inline-flex items-center px-3 py-1.5 border border-transparent rounded-md text-xs font-medium text-white bg-green-600 hover:bg-green-700" data-id="element-3055">
                        <CheckIcon className="h-4 w-4 mr-1" data-id="element-3056" />
                        Resolve
                      </button>
                      <button onClick={() => {
                setShowDetailModal(false);
                openStatusUpdateModal(selectedDispute, 'rejected');
              }} className="inline-flex items-center px-3 py-1.5 border border-transparent rounded-md text-xs font-medium text-white bg-red-600 hover:bg-red-700" data-id="element-3057">
                        <XIcon className="h-4 w-4 mr-1" data-id="element-3058" />
                        Reject
                      </button>
                    </>}
                {selectedDispute.status === 'open' && <button onClick={() => {
              setShowDetailModal(false);
              openStatusUpdateModal(selectedDispute, 'under_review');
            }} className="inline-flex items-center px-3 py-1.5 border border-transparent rounded-md text-xs font-medium text-white bg-yellow-600 hover:bg-yellow-700" data-id="element-3059">
                    <ClockIcon className="h-4 w-4 mr-1" data-id="element-3060" />
                    Mark Under Review
                  </button>}
              </div>
            </div>

            {/* Dispute Information */}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-3061">
              <div data-id="element-3062">
                <h3 className="text-sm font-medium text-gray-500 dark:text-gray-400 mb-2" data-id="element-3063">
                  Dispute Information
                </h3>
                <div className="bg-gray-50 dark:bg-gray-800 p-3 rounded-md space-y-2" data-id="element-3064">
                  <div className="flex justify-between" data-id="element-3065">
                    <span className="text-sm font-medium" data-id="element-3066">Dispute ID:</span>
                    <span className="text-sm" data-id="element-3067">{selectedDispute.id}</span>
                  </div>
                  <div className="flex justify-between" data-id="element-3068">
                    <span className="text-sm font-medium" data-id="element-3069">Type:</span>
                    <span className="text-sm" data-id="element-3070">
                      {getDisputeTypeBadge(selectedDispute.disputeType)}
                    </span>
                  </div>
                  <div className="flex justify-between" data-id="element-3071">
                    <span className="text-sm font-medium" data-id="element-3072">Amount:</span>
                    <span className="text-sm" data-id="element-3073">
                      {formatAmount(selectedDispute.amount, selectedDispute.currency)}
                    </span>
                  </div>
                  <div className="flex justify-between" data-id="element-3074">
                    <span className="text-sm font-medium" data-id="element-3075">Date Raised:</span>
                    <span className="text-sm" data-id="element-3076">
                      {formatDate(selectedDispute.dateRaised)}
                    </span>
                  </div>
                  <div className="flex justify-between" data-id="element-3077">
                    <span className="text-sm font-medium" data-id="element-3078">Last Updated:</span>
                    <span className="text-sm" data-id="element-3079">
                      {formatDate(selectedDispute.lastUpdated)}
                    </span>
                  </div>
                  <div className="flex justify-between" data-id="element-3080">
                    <span className="text-sm font-medium" data-id="element-3081">Assigned To:</span>
                    <span className="text-sm" data-id="element-3082">
                      {selectedDispute.assignedTo}
                    </span>
                  </div>
                </div>
              </div>
              <div data-id="element-3083">
                <h3 className="text-sm font-medium text-gray-500 dark:text-gray-400 mb-2" data-id="element-3084">
                  Transaction Information
                </h3>
                <div className="bg-gray-50 dark:bg-gray-800 p-3 rounded-md space-y-2" data-id="element-3085">
                  <div className="flex justify-between" data-id="element-3086">
                    <span className="text-sm font-medium" data-id="element-3087">Transaction ID:</span>
                    <span className="text-sm" data-id="element-3088">
                      {selectedDispute.transactionId}
                    </span>
                  </div>
                  <div className="flex justify-between" data-id="element-3089">
                    <span className="text-sm font-medium" data-id="element-3090">Merchant:</span>
                    <span className="text-sm" data-id="element-3091">
                      {selectedDispute.merchantName}
                    </span>
                  </div>
                  <div className="flex justify-between" data-id="element-3092">
                    <span className="text-sm font-medium" data-id="element-3093">Merchant ID:</span>
                    <span className="text-sm" data-id="element-3094">
                      {selectedDispute.merchantId}
                    </span>
                  </div>
                  <div className="flex justify-between" data-id="element-3095">
                    <span className="text-sm font-medium" data-id="element-3096">Customer:</span>
                    <span className="text-sm" data-id="element-3097">
                      {selectedDispute.customerName}
                    </span>
                  </div>
                  <div className="flex justify-between" data-id="element-3098">
                    <span className="text-sm font-medium" data-id="element-3099">
                      Customer Contact:
                    </span>
                    <span className="text-sm" data-id="element-3100">
                      {selectedDispute.customerContact}
                    </span>
                  </div>
                </div>
              </div>
            </div>

            {/* Description */}
            <div data-id="element-3101">
              <h3 className="text-sm font-medium text-gray-500 dark:text-gray-400 mb-2" data-id="element-3102">
                Dispute Description
              </h3>
              <div className="bg-gray-50 dark:bg-gray-800 p-3 rounded-md" data-id="element-3103">
                <p className="text-sm" data-id="element-3104">{selectedDispute.description}</p>
              </div>
            </div>

            {/* Documents */}
            <div data-id="element-3105">
              <h3 className="text-sm font-medium text-gray-500 dark:text-gray-400 mb-2" data-id="element-3106">
                Supporting Documents
              </h3>
              <div className="bg-gray-50 dark:bg-gray-800 p-3 rounded-md" data-id="element-3107">
                {selectedDispute.documents.length > 0 ? <ul className="space-y-2" data-id="element-3108">
                    {selectedDispute.documents.map((doc, index) => <li key={index} className="flex items-center" data-id="element-3109">
                        <FileTextIcon className="h-4 w-4 mr-2 text-gray-500 dark:text-gray-400" data-id="element-3110" />
                        <span className="text-sm text-blue-600 dark:text-blue-400 hover:underline cursor-pointer" data-id="element-3111">
                          {doc}
                        </span>
                      </li>)}
                  </ul> : <p className="text-sm text-gray-500 dark:text-gray-400" data-id="element-3112">
                    No documents attached
                  </p>}
              </div>
            </div>

            {/* Timeline */}
            <div data-id="element-3113">
              <h3 className="text-sm font-medium text-gray-500 dark:text-gray-400 mb-2" data-id="element-3114">
                Dispute Timeline
              </h3>
              <div className="bg-gray-50 dark:bg-gray-800 p-3 rounded-md" data-id="element-3115">
                <ol className="relative border-l border-gray-300 dark:border-gray-700 ml-3" data-id="element-3116">
                  {selectedDispute.timeline.map((event, index) => <li key={index} className="mb-6 ml-6" data-id="element-3117">
                      <span className="absolute flex items-center justify-center w-6 h-6 bg-blue-100 rounded-full -left-3 ring-8 ring-white dark:ring-gray-800 dark:bg-blue-900" data-id="element-3118">
                        <InfoIcon className="w-3 h-3 text-blue-800 dark:text-blue-300" data-id="element-3119" />
                      </span>
                      <div className="flex items-center justify-between mb-1" data-id="element-3120">
                        <time className="block text-xs font-normal leading-none text-gray-500 dark:text-gray-400" data-id="element-3121">
                          {formatDate(event.date)}{' '}
                          {new Date(event.date).toLocaleTimeString()}
                        </time>
                        <span className="text-xs text-gray-500 dark:text-gray-400" data-id="element-3122">
                          {event.user}
                        </span>
                      </div>
                      <h3 className="text-sm font-semibold text-gray-900 dark:text-white" data-id="element-3123">
                        {event.action}
                      </h3>
                      <p className="text-xs text-gray-600 dark:text-gray-400" data-id="element-3124">
                        {event.details}
                      </p>
                    </li>)}
                </ol>
              </div>
            </div>

            <div className="flex justify-end pt-4 border-t dark:border-gray-700" data-id="element-3125">
              <button onClick={() => setShowDetailModal(false)} className="px-4 py-2 border border-gray-300 dark:border-gray-600 rounded-md text-sm font-medium text-gray-700 dark:text-gray-200 bg-white dark:bg-gray-800 hover:bg-gray-50 dark:hover:bg-gray-700" data-id="element-3126">
                Close
              </button>
            </div>
          </div>
        </Modal>}

      {/* Status Update Modal */}
      <Modal isOpen={showStatusModal} onClose={() => setShowStatusModal(false)} title={`Update Dispute Status - ${disputeToUpdate?.id}`} size="md" data-id="element-3127">
        <div className="space-y-4" data-id="element-3128">
          <div data-id="element-3129">
            <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1" data-id="element-3130">
              New Status
            </label>
            <div className="flex items-center" data-id="element-3131">{getStatusBadge(newStatus)}</div>
          </div>
          <div data-id="element-3132">
            <label htmlFor="statusReason" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1" data-id="element-3133">
              Reason for Status Change
            </label>
            <textarea id="statusReason" rows={3} placeholder="Enter reason for status change..." value={statusUpdateReason} onChange={e => setStatusUpdateReason(e.target.value)} className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-md shadow-sm text-sm bg-white dark:bg-gray-800" required data-id="element-3134" />
          </div>
          <div className="flex justify-end space-x-3 pt-4 border-t dark:border-gray-700" data-id="element-3135">
            <button onClick={() => setShowStatusModal(false)} className="px-4 py-2 border border-gray-300 dark:border-gray-600 rounded-md text-sm font-medium text-gray-700 dark:text-gray-200 bg-white dark:bg-gray-800 hover:bg-gray-50 dark:hover:bg-gray-700" data-id="element-3136">
              Cancel
            </button>
            <button onClick={updateDisputeStatus} disabled={!statusUpdateReason} className={`px-4 py-2 border border-transparent rounded-md text-sm font-medium text-white ${!statusUpdateReason ? 'bg-blue-400 cursor-not-allowed' : 'bg-blue-600 hover:bg-blue-700'}`} data-id="element-3137">
              Update Status
            </button>
          </div>
        </div>
      </Modal>

      {/* Export Modal */}
      <Modal isOpen={showExportModal} onClose={() => setShowExportModal(false)} title="Export Disputes" size="md" data-id="element-3138">
        <div className="space-y-4" data-id="element-3139">
          <p className="text-sm text-gray-500 dark:text-gray-400" data-id="element-3140">
            Choose a format to export the current dispute list:
          </p>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4" data-id="element-3141">
            <button onClick={() => handleExport('csv')} className="p-4 border border-gray-300 dark:border-gray-600 rounded-md hover:bg-gray-50 dark:hover:bg-gray-800 flex flex-col items-center" data-id="element-3142">
              <FileTextIcon className="h-10 w-10 text-blue-500 mb-2" data-id="element-3143" />
              <span className="text-sm font-medium" data-id="element-3144">CSV Format</span>
              <span className="text-xs text-gray-500 dark:text-gray-400" data-id="element-3145">
                Export as CSV file
              </span>
            </button>
            <button onClick={() => handleExport('xlsx')} className="p-4 border border-gray-300 dark:border-gray-600 rounded-md hover:bg-gray-50 dark:hover:bg-gray-800 flex flex-col items-center" data-id="element-3146">
              <FileTextIcon className="h-10 w-10 text-green-500 mb-2" data-id="element-3147" />
              <span className="text-sm font-medium" data-id="element-3148">XLSX Format</span>
              <span className="text-xs text-gray-500 dark:text-gray-400" data-id="element-3149">
                Export as Excel file
              </span>
            </button>
            <button onClick={() => handleExport('pdf')} className="p-4 border border-gray-300 dark:border-gray-600 rounded-md hover:bg-gray-50 dark:hover:bg-gray-800 flex flex-col items-center" data-id="element-3150">
              <FileTextIcon className="h-10 w-10 text-red-500 mb-2" data-id="element-3151" />
              <span className="text-sm font-medium" data-id="element-3152">PDF Format</span>
              <span className="text-xs text-gray-500 dark:text-gray-400" data-id="element-3153">
                Export as PDF file
              </span>
            </button>
          </div>
          <div className="mt-4 pt-4 border-t border-gray-200 dark:border-gray-700" data-id="element-3154">
            <button onClick={() => setShowExportModal(false)} className="w-full px-4 py-2 border border-gray-300 dark:border-gray-600 rounded-md text-sm font-medium text-gray-700 dark:text-gray-200 bg-white dark:bg-gray-800 hover:bg-gray-50 dark:hover:bg-gray-700" data-id="element-3155">
              Cancel
            </button>
          </div>
        </div>
      </Modal>
    </div>;
};
export default DisputeList;